<div class="mat-dialog-content">
  <div mat-dialog-title>
    <div class="head-select-room-modal-list">
      <mat-icon (click)="close()" class="close-modal">close</mat-icon>
      @if (listSadtOpen && listSadtOpen.length > 0) {
        <div class="col-12 open-sadt">
          <div class="title-modal">
            <h1><b>Atenção!</b></h1>
          </div>
          <div class="img-head">
            <img style="width: 5rem;" src="assets/images/exclamation-circle.png" />
          </div>
          <span>O paciente possui os seguintes tipos de exames a serem realizados: </span>
          <div class="col-12 sadt-content">
            @for (item of listSadtOpen; track item) {
              <span>
                <mat-icon aria-hidden="false">done</mat-icon>
                {{item.typeSadtName}}@if (item.quantity > 1) {
                <span> ({{item.quantity}})</span>
                }<br>
              </span>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div mat-dialog-content>
    <div class="body-select-room-modal-list">
      <h2>Encaminhar Paciente</h2>
      <div class="filters">
        <div class="row">
          <mat-form-field appearance="outline">
            <mat-icon matPrefix class="my-icon">search</mat-icon>
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
              (keyup)="onKeySearch()">
            </mat-form-field>
          </div>
        </div>
        @if (isLoading) {
          <app-loading-list></app-loading-list>
        }
        <div class="body-select-room-modal-list__options">
          @for (item of filteredListforward; track item) {
            <div mat-flat-button color="accent" class=" body-select-room-modal-list__options--buttons"
              (click)="selectItem(item.idFlow)">
              <span class="option-name truncate">{{item.locationName}} </span>
              <mat-icon class="option-icon">navigate_next</mat-icon>
            </div>
          }
        </div>
      </div>
    </div>
  </div>